import L from 'leaflet'
import 'leaflet.gridlayer.googlemutant'

export const mapTypes = [
    { value: 'google-roadmap', text: 'Google Roads' },
    { value: 'google-terrain', text: 'Google Terrain' },
    { value: 'google-satellite', text: 'Google Satellite' },
    { value: 'google-hybrid', text: 'Google Hybrid' },
    { value: 'osm', text: 'Open street map' },
    { value: 'bing-Road', text: 'Bing Roads' },
    { value: 'bing-Aerial', text: 'Bing Aerial' },
];

export const defaultMap = 'google-roadmap';

const providers = {
    google: {
        options:{
            apiKey: 'AIzaSyCE4Xmg99rD4T2yassrQK9pGMCgcJQ70Aw',
            type: 'roadmap'
        },
        createLayer({apiKey, type}) {
            const googleMutant = L.gridLayer.googleMutant({ type: type });
            if (!(typeof google === 'object' && typeof google.maps === 'object')) {
                let googleScript = document.createElement('script');
                googleScript.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=' + apiKey);
                document.head.appendChild(googleScript);
                googleScript.onload = ()=>{
                    return googleMutant;
                }
            }
            return googleMutant;
        }
    },
    osm:{
        options: {
            url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png'
        },
        createLayer({url}){
            return L.tileLayer(url)
        }
    }
};

export const tileManger = {
    mapObject: null,
    tileLayer: null,

    init(mapObject){
        this.mapObject = mapObject;
        this.setMap(defaultMap);
    },

    addTileLayer(){
        if(this.mapObject && this.tileLayer){
            this.tileLayer.addTo(this.mapObject);
        }
    },

    removeTileLayer(){
        if(this.mapObject && this.tileLayer){
            this.tileLayer.removeFrom(this.mapObject);
            this.tileLayer = null;
        }
    },

    setMap(map){
        this.removeTileLayer();
        let mapData = !map ? defaultMap.split('-') : map.split('-');
        let provider = providers[mapData[0]];

        if(mapData[1]){
            provider.options.type = mapData[1];
        }
        this.tileLayer = provider.createLayer(provider.options);
        this.addTileLayer();
    }
};